"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var react_id_generator_1 = tslib_1.__importDefault(require("react-id-generator"));

var styles = tslib_1.__importStar(require("./Stepper.style"));

var Step_1 = tslib_1.__importDefault(require("./Step"));

function Stepper(_ref) {
  var steps = _ref.steps,
      status = _ref.status,
      className = _ref.className;

  if (steps.length !== status.length) {
    console.error('Stepper require same length between steps, status');
  }

  return jsx_runtime_1.jsx("div", Object.assign({
    className: className,
    css: styles.container
  }, {
    children: status.map(function (_ref2, index) {
      var going = _ref2.going,
          done = _ref2.done;
      var existLine = status.length >= 2 && index !== status.length - 1;
      var isActiveLine = index + 1 < status.length && status[index + 1].done;
      return jsx_runtime_1.jsxs(react_1.Fragment, {
        children: [jsx_runtime_1.jsx(Step_1.default, Object.assign({
          index: index + 1,
          going: going,
          done: done
        }, {
          children: steps[index]
        }), void 0), existLine && jsx_runtime_1.jsx("div", {
          className: "mrt-progress-line",
          css: [styles.progressLine, isActiveLine && styles.activeProgressLine]
        }, void 0)]
      }, react_id_generator_1.default());
    })
  }), void 0);
}

exports.default = react_1.memo(Stepper);